module.exports = __webpack_public_path__ + "static/media/Bilguun.9e9853fe.png";